import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
const Home = () => import( /* webpackChunkName: "Home" */ '@/views/Home.vue')
const More = () => import( /* webpackChunkName: "More" */ '@/views/More.vue')
const Search = () => import( /* webpackChunkName: "Search" */ '@/views/Search.vue')
const Details = () => import( /* webpackChunkName: "Details" */ '@/views/Details.vue')
const PDetails = () => import( /* webpackChunkName: "phoneDetails" */ '@/views/phoneDetails.vue')

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	component: Home
}, {
	path: '/more',
	name: 'More',
	component: More
}, {
	path: '/search',
	name: 'Search',
	component: Search
}, {
	path: '/details',
	name: 'Details',
	component: Details
}, {
	path: '/pDetails',
	name: 'PDetails',
	component: PDetails
}, ]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router